import { fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
const BASE_URL = 'dashboard/v1/tag';
export const getTags = (query = {}) => {
  return http.get(BASE_URL, {
    query
  }).then(fromJS);
};